export default () => [
  location.protocol,
  '//',
  location.host,
  location.pathname
].join('')
